import Styled from "@emotion/styled";
import { Grid } from "@mui/material";

export const SocialNetworkContainer = Styled(Grid)`
    background: #F0F3F7;
    border-radius: 6px;
    padding: 20px;
`;
